import { render, staticRenderFns } from "./Instructionsfor.vue?vue&type=template&id=1eac57dc&scoped=true&"
import script from "./Instructionsfor.vue?vue&type=script&lang=js&"
export * from "./Instructionsfor.vue?vue&type=script&lang=js&"
import style0 from "./Instructionsfor.vue?vue&type=style&index=0&id=1eac57dc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eac57dc",
  null
  
)

export default component.exports